class LookBookItem extends HTMLElement {
  constructor() {
    super();
    if (window.innerWidth < 768) {
      const image = this.querySelector(".js-image-source").src;
      const title = this.querySelector(".js-title-source").innerHTML;
      const option = this.querySelector(".js-option-source").innerHTML;
      const price = this.querySelector(".js-price-source").innerHTML;
      const url = this.querySelector(".js-url-source").href;
      const modal = document.querySelector(".lookbook-modal");
      const bullet = this.querySelector(".lookbook-product");
      const close = modal.querySelector(".lookbook-close");
      const imageDest = document.querySelector(".js-image");
      const titleDest = document.querySelector(".js-title");
      const optionDest = document.querySelector(".js-option");
      const priceDest = document.querySelector(".js-price");
      const urlDest = document.querySelector(".js-url");
      const fillModal = () => {
        imageDest.src = image.replace("&width=120", "&width=900");
        titleDest.innerHTML = title;
        optionDest.innerHTML = option;
        priceDest.innerHTML = price;
        urlDest.href = url;
      };
      bullet.addEventListener("click", () => {
        fillModal();
        modal.classList.add("js-visible");
      });
      close.addEventListener("click", () => {
        modal.classList.remove("js-visible");
      });
    }
  }
}
if (customElements.get("lookbook-item") === void 0) {
  customElements.define("lookbook-item", LookBookItem);
}
